import { connect } from "react-redux";

import RegulationDetail from "../../components/main_components/regulation_detail";

const mapStateToProps = (state) => {
  const regulation = state.navigation.focusView.regulationDetail.data.regulations[0];
  const standardsCount = state.loading.data.mainRegulationStandardsTotal;
  const regulationBaseHref = "/data-hub/regulations/by-regulation";

  return { regulation, standardsCount, regulationBaseHref };
};

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(RegulationDetail);
